import {loadComponents} from 'https://cdn.jsdelivr.net/npm/ict-shopify@1.5.7/loader.js';
await loadComponents(false);

async function themeComponent(url, async=true, checkDom=false) {
  const tagName = url.replace(/.*\//, '').replace(/\?.*/, '').replace('cmp-', '').replace('.js', '');
  // camelizza il nome del tag e metti in maiuscolo la prima lettera
  const className = tagName.replace(/-([a-z])/g, (g) => g[1].toUpperCase()).replace(/^./, (g) => g.toUpperCase());
  
  // se il tag è già definito non lo carico
  if(!window[className] == undefined){
    return;
  }

  // se devo controllare il dom e non trovo il tag non lo carico
  if(checkDom && document.querySelector(tagName) == null){
    return;
  }
  
  if(async){
    import(url).catch(e => {
      console.error(`Errore nel caricamento del componente ${tagName}:`, e);
    });
  } else {
    await import(url);
  }
}
window.themeComponent = themeComponent;

for (const key of Object.keys(theme.resources)) {
  themeComponent(theme.resources[key]);
}
for (const key of Object.keys(theme.components)) {
  themeComponent(theme.components[key]);
}

// attivo la wishlist
await themeComponent(theme.resources['wishlist'],false);
Wishlist.checkCustomer();

// attivo i popover di bootstrap
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))